<template>
    <div v-if="facet.name" class="p-3 bg-white border-bottom">
        <div class="h3">{{ facetName }}</div>

        <div v-if="facet.type === 'price'">
            <item-filter-price></item-filter-price>
        </div>

        <div
            v-else-if="facet.cssClass === 'has-pictures'"
            :class="{'row-cols-3': facets.length >= 3, 'row-cols-2': facets.length < 3}"
            class="row flex-wrap text-center mx-n1"
        >
            <div class="col my-1 px-1" v-for="value in facets" :key="value.id">
                <input :id="'option-' + value.id + '-' + _uid" class="form-check-input d-none" type="checkbox" :checked="isSelected(value.id)" @change="updateFacet(value)" :disabled="isLoading || value.count <= 0">
                <label :for="'option-' + value.id + '-' + _uid" class="form-check-label border rounded-lg p-0" :class="[paddingClasses, isSelected(value.id) ? 'bg-appearance' : '', 'option-' + value.id]" :style="paddingInlineStyles">
                  <figure class="figure m-0">
                    <img
                        :alt="value.name"
                        :src="'https://cdn02.plentymarkets.com/dqaqtvmxowl5/frontend/facetten/'+facet.id+'/'+value.id+'.webp'"
                        :title="value.name"
                        class="img-fluid"
                        decoding="async"
                        loading="lazy"
                    >
                    <figcaption class="figure-caption text-center mt-2">{{ value.name }}</figcaption>
                  </figure>
                </label>
            </div>
        </div>

        <div v-else class="d-flex flex-wrap text-center mx-n1">
            <div class="my-1 px-1 flex-grow-1" v-for="value in facets" :key="value.id">
                <input :id="'option-' + value.id + '-' + _uid" class="form-check-input d-none" type="checkbox" :checked="isSelected(value.id)" @change="updateFacet(value)" :disabled="isLoading || value.count <= 0">
                <label :for="'option-' + value.id + '-' + _uid" class="form-check-label border rounded-lg px-0" :class="[paddingClasses, isSelected(value.id) ? 'bg-appearance' : '', 'option-' + value.id]" :style="paddingInlineStyles">
                    <div class="d-flex">
                        <span class="flex-grow-1">{{ value.name }}</span>
                    </div>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ItemFilterPrice from "./ItemFilterPrice.vue";

export default {

    name: "item-filter",

    components:
    {
        ItemFilterPrice
    },

    props:
    {
        facet:
        {
            type: Object
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        }
    },

    computed:
    {
        facets()
        {
            return this.facet.values;
        },

        facetName()
        {
            if (this.facet.translationKey && this.facet.translationKey.length > 0)
            {
                return this.$translate("Ceres::Template." + this.facet.translationKey);
            }

            return this.facet.name;
        },

        ...mapState({
            selectedFacets: state => state.itemList.selectedFacets,
            isLoading: state => state.itemList.isLoading
        })
    },

    methods:
    {
        updateFacet(facetValue)
        {
            const toolbarElements = document.getElementsByClassName("widget-toolbar");

            for (const toolbarElement of toolbarElements)
            {
                if (toolbarElement.contains(this.$vnode.elm))
                {
                    window.localStorage.setItem("openFilterToolbar", true);
                }
            }

            this.$store.dispatch("selectFacet", { facetValue });
        },

        isSelected(facetValueId)
        {
            return this.selectedFacets.findIndex(selectedFacet => selectedFacet.id === facetValueId) > -1;
        }
    }
}
</script>
